import { Slide } from 'components/UI/V2/Carousel/Slide';

export const getHelpSlides = (description: React.ReactNode, isMobile: boolean): Slide[] => [
    {
        id: 1,
        title: !isMobile ? 'Help & Support' : '',
        description: description,
        marginRightDescription: '0px',
        image: 'images/sliders/help/slider-help-1.jpg'
    }
];
